import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection, userStaleDataStore } from "../Common";
export class BetslipConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.betslip, meta);
    }
    calculateBets(q) {
        return this.applyQuery(QueryBuilder.calculateBets(q));
    }
    /**
     * Currently not implemented in Online.Sbtech.BetsCompositeBFF, however endoint and Request type are added
     */
    calculateYourBetBets(q) {
        return this.applyQuery(QueryBuilder.calculateYourbetBets(q));
    }
    placeBets(q) {
        return this.applyQuery(QueryBuilder.placeBets(q));
    }
    updatePurchases(q) {
        return this.applyQuery(QueryBuilder.updatePurchases(q));
    }
    getPurchases(q) {
        return this.applyQuery(QueryBuilder.getPurchases(q));
    }
    onStaleData(cb) {
        userStaleDataStore.set(cb, this);
    }
    offStaleData(cb) {
        if (typeof cb !== "undefined") {
            userStaleDataStore.delete(cb, this);
        }
        else {
            userStaleDataStore.deleteConnection(this);
        }
    }
}
;
//# sourceMappingURL=BetslipConnection.js.map